const testimonials = [
  {
    text: '[Client testimonial coming soon — Carol welcomes genuine feedback from recent sellers.]',
    author: '— Placeholder',
    rating: 5,
  },
  {
    text: '[Client testimonial coming soon — Carol welcomes genuine feedback from recent sellers.]',
    author: '— Placeholder',
    rating: 5,
  },
  {
    text: '[Client testimonial coming soon — Carol welcomes genuine feedback from recent sellers.]',
    author: '— Placeholder',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100/70">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="text-primary-500 font-body text-sm tracking-widest uppercase mb-3">
            Testimonials
          </p>
          <h2 className="font-heading text-foreground-900 text-2xl md:text-3xl lg:text-4xl mb-4">
            What Homeowners Say
          </h2>
          <p className="text-foreground-600 font-body text-base max-w-[550px] mx-auto">
            Real feedback from homeowners Carol has helped. Your experience
            could be next.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-lg p-6"
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-accent-500 text-sm" />
                ))}
              </div>
              <p className="text-foreground-600 font-body text-sm leading-relaxed italic mb-4">
                "{t.text}"
              </p>
              <p className="text-foreground-500 font-body text-xs">
                {t.author}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}